import FirmwareBuildsPage from './FirmwareBuildsPage.js';
import FirmwareAssignmentsPage from './FirmwareAssignmentsPage.js';
import FirmwareUpdatesPage from './FirmwareUpdatesPage.js';

export async function registerFirmwarePages(app) {
    app.registerPage('global/firmware/builds', FirmwareBuildsPage);
    app.registerPage('group/firmware', FirmwareAssignmentsPage);
    app.registerPage('group/firmware/updates', FirmwareUpdatesPage);
}
